<template>
  <dialog
    ref="dialog"
    v-click-away="out"
    class="formester-dialog"
    :class="{ 'backdrop-blur': blurBackground }"
  >
    <slot />
  </dialog>
</template>

<script>
import { directive } from "vue3-click-away";

export default {
  name: "FormesterModal",
  directives: {
    ClickAway: directive,
  },
  props: {
    blurable: {
      type: Boolean,
      default: false,
    },
    blurBackground: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["close"],
  mounted() {
    document.addEventListener("keydown", this.onEscape);
  },
  methods: {
    open() {
      this.$refs.dialog.showModal();
    },
    close() {
      this.$emit("close");
      this.$refs.dialog.close();
    },
    out() {
      if (this.blurable) {
        this.close();
      }
    },
    onEscape(e) {
      if (e.keyCode === 27) {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.formester-dialog {
  border: none;
  border-radius: 4px;
  min-width: 300px;
  outline: none;
}

.formester-dialog::backdrop {
  pointer-events: none;
}

.backdrop-blur::backdrop {
  backdrop-filter: blur(10px);
}
</style>
